import {BootGlobals} from "../boot.globals";
import {Authenticator} from "../services/slc/slc.authenticator";
import {AppConfigLoader} from "./app-config-loader";
import {ClientConfiguration} from "../services/configuration/client.config";
import {StartupHttpService} from "../services/http/startup.http.service";
import {Injectable} from "@angular/core";
import {Observable, Observer} from "rxjs";
import {switchMap} from "rxjs/operators";

@Injectable()
export class BrowserBoot {

    constructor(private appConfigLoader: AppConfigLoader,
                private authenticator: Authenticator,
                private clientConfiguration: ClientConfiguration,
                private httpService: StartupHttpService) {
    }

    public initialize(): Observable<string>{
      return new Observable( (observer:Observer<any>) => {
        BootGlobals.config = this.clientConfiguration;
        this.setAppRoot();
        this.setExitEventListener();
        this.setSlcPath();

        this.httpService.initialize();
        this.appConfigLoader.loadFromURL();
        this.appConfigLoader.loadFromLocalPropertyFile().pipe(
          switchMap(() => this.authenticator.authenticate()),
          switchMap(() => this.appConfigLoader.loadFromRemotePropertyFile())
        ).subscribe(() => {
          observer.next("OK");
          observer.complete();
        });
      });
    }

    private setSlcPath(): void {
        let a = document.createElement("a");
        a.href = document.referrer;

        let protocol = "https:";
        if (a.host.indexOf("localhost") >= 0) {
            protocol = "http:";
        }

        let slcLocation = protocol + "//" + a.host + "/slc";
        BootGlobals.config.setSlcLocation(slcLocation);
        console.log("slc location = " + slcLocation);
    }

    private setAppRoot(): void {
        BootGlobals.appRoot = "/";
    }

    private setExitEventListener(): void {
        document.addEventListener("productExit", () => {
            window.open("", "_parent", "");
            window.close();
        });
    }

}
